import styled from 'styled-components'
import { Link as LinkS } from 'react-scroll'


export const Nav = styled.nav`
    background: rgb(171,163,241);
    background: linear-gradient(222deg, rgba(171,163,241,1) 34%, rgba(249,148,202,1) 100%);
    height: 80px;
    width: 100%;
    margin: auto;
    margin-top: -80px;
    display: flex;
    opacity: ${({scrollNav}) => (scrollNav ? '100' : '0')};
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;
    transition: all .5s ease;
    
`;

export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    max-width: 1100px;
`
export const LogoContainer = styled(LinkS)`
    display: flex;
    justify-content: space-evenly;
    text-decoration: none;
    cursor: pointer;
`

export const NavImg = styled.img`
    height: 80px;
    width: 80px;
    margin-left: -24px;

    @media screen and (max-width: 768px){
        height: 50px;
        width: 50px;
    }
`

export const NavLogo = styled.div`
    color: #5e3f75;
    font-size: 2rem;
    letter-spacing: 3px;
    display: flex;
    align-items: flex-end;
    font-weight: bold;
    /* text-shadow: 1px 1px 1px black; */
`;

export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 768px){
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem;
        cursor: pointer;
        color: #fff;
    }
`;

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -22px;

    @media screen and (max-width: 768px){
        display: none;
    }
`

export const NavItem = styled.li`
    height: 80px;
`

export const NavLinks = styled(LinkS)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    font-family: 'montserrat';
    font-size: 1.5rem;
    text-shadow: 1.5px 1.5px 1px black;

    &.active {
        border-bottom: 3px solid purple;
    }
`

export const NavBtn = styled.nav`
    display: flex;
    align-items: center;

    @media screen and (max-width: 768px){
        display: none;
    }
`

